<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <h3 class="mb-5">
      Pranešimai apie transporto priemones (TP) iš KTPR ir TPSAIS
    </h3>

    <v-row>
      <v-col cols="12" md="3">
        <el-date-picker label="Data nuo" v-model="dataNuo" />
      </v-col>
      <v-col cols="12" md="3">
        <el-date-picker label="Data iki" v-model="dataIki" />
      </v-col>
      <v-col cols="12" md="3" class="mt-2">
        <el-button
          primary
          :loading="loading"
          @click.native.stop="getData(true)"
        >
          Ieškoti
        </el-button>
        <el-button :loading="loading" @click.native="clearData()">
          Išvalyti
        </el-button>
      </v-col>
    </v-row>
    <v-row v-if="showFormuoti">
      <v-col cols="12" md="3">
        <el-date-picker label="Formuoti nuo" v-model="formuotiNuo" />
      </v-col>
      <v-col cols="12" md="3" class="mt-2">
        <el-button :loading="loading" @click.native.stop="formuotiAtaskaita()">
          Formuoti
        </el-button>
      </v-col>
    </v-row>
    <v-data-table
      class="mb-4"
      :loading="loading"
      :headers="headers"
      :items="filterItemList"
      :item-class="rowClass"
      :hide-default-footer="hideFooter"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <template #[`item.rgp_busena_title`]="{ item }">
        <el-hipoteka-busena :busena="item.rgp_busena_title" />
      </template>
      <template #[`item.actions`]="{ item }">
        <template v-if="!item.formuoti_btn">
          <div class="nowrap">
            <el-byla
              :class="byla.class"
              v-for="byla in item.bylos"
              :key="byla.byl_id"
              :byla="byla"
              :withName="byla.withName"
              in-line
            />
          </div>
        </template>
        <template v-if="item.formuoti_btn">
          <el-button
            :loading="loading"
            @click.native.stop="formuotiAtaskaita()"
          >
            Formuoti
          </el-button>
        </template>
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template slot="loading">
        kraunasi
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '../../mixins/userRole'

export default {
  name: 'RegitraPranesimai',
  mixins: [userRole],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: true,
      loading: true,
      paginationloading: false,
      search: null,
      showDelete: false,
      modalDeleteVardas: '',
      modalDeleteItem: null,
      pranesimai: [],
      searchData: {},
      headers: [
        {
          text: 'Suformavimo data ir laikas',
          align: 'start',
          value: 'rgp_sukurimo_data',
        },
        {
          text: 'Laikotarpis nuo',
          align: 'start',
          value: 'rgp_laikotarpis_nuo',
        },
        {
          text: 'Laikotarpis iki',
          align: 'start',
          value: 'rgp_laikotarpis_iki',
        },
        {
          text: 'Veiksmus atlikęs asmuo',
          align: 'start',
          value: 'rgp_sukure',
        },
        {
          text: 'Formavimo būsena',
          align: 'start',
          value: 'rgp_busena_title',
        },
        {
          text: 'Ataskaita',
          align: 'center',
          sortable: false,
          value: 'actions',
        },
      ],
      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
      lockInterval: null,
      lockTimeout: 10000,

      dataNuo: null,
      dataIki: null,
      formuotiNuo: null,
      forceFormuoti: false,
    }
  },
  computed: {
    ...mapGetters(['getLockObjId']),

    filterItemList() {
      return this.pranesimai.map((item, index) => {
        item.bylos = item.bylos.map(byla => {
          byla.byl_url = `byla/${byla.byl_id}/${byla.byl_hash}/content`
          byla.byl_tipas = 'regitra'
          byla.byl_pavadinimas = `Regitra pranešimas ${item.rgp_sukurimo_data}.xlsx`

          return byla
        })

        item.formuoti_btn =
          index == 0 && item.rgp_busena == 'nesuformuota' && this.forceFormuoti

        return item
      })
    },
    hideFooter() {
      return this.pagination.total <= 10
    },
    canPrint() {
      return this.filterItemList.length === 0
    },
    isFormuojama() {
      return (
        this.pranesimai.filter(item => item.rgp_busena === 'formuojama')
          .length > 0
      )
    },
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    isDevelop() {
      return process.env.VUE_APP_LOCAL === 'develop'
    },
    isTest() {
      return process.env.VUE_APP_LOCAL === 'test'
    },
    showFormuoti() {
      return this.isLocal || this.isDevelop || this.isTest
    },
  },
  beforeDestroy() {
    this.stopLoading()
  },
  created() {
    this.getData()
  },
  methods: {
    getData(resetPageNr = false) {
      if (resetPageNr) {
        this.pagination.page = 1
      }
      const data = {
        search: {
          data_nuo: this.dataNuo,
          data_iki: this.dataIki,
        },
        ...this.pagination,
      }

      this.$axios
        .post(`regitra`, data)
        .then(res => {
          this.pranesimai = res.data.pranesimai
          this.pagination = { ...this.pagination, ...res.data.pagination }
          this.forceFormuoti = res.data.force_formuoti
          this.checkLoading()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    checkLoading() {
      if (this.isFormuojama) {
        if (!this.lockInterval) {
          this.lockInterval = setInterval(() => {
            this.getData()
          }, this.lockTimeout)
        }
      } else {
        this.stopLoading()
      }
    },
    stopLoading() {
      clearInterval(this.lockInterval)
    },
    clearData() {
      this.dataNuo = null
      this.dataIki = null
      this.getData()
    },
    formuotiAtaskaita() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loading = true
          const data = {
            rgp_laikotarpis_nuo: this.formuotiNuo,
          }

          this.$axios
            .post(`regitra/store`, data)
            .then(res => {
              window._VMA.$emit('DATA_OK', res.data.message)
              this.getData(true)
            })
            .catch(err => {
              window._VMA.$emit('DATA_ERROR', err.response.data.message)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          window._VMA.$emit('FORMAT_ERROR')
        }
      })
    },
    rowClass(item) {
      return ''
    },
  },
}
</script>
<style lang="scss" scoped>
.potipis {
  background: #8eb693;

  .v-card__text {
    &.active {
      background: #2c7837;
      color: #fff;
    }
  }
}
</style>
